import { Popover, PopoverContent, PopoverTrigger } from '@optools/components/ui/popover';
import { CircleHelp, LucideProps } from 'lucide-react';

interface Content {
  description: string;
  icon: React.ForwardRefExoticComponent<
    Omit<LucideProps, 'ref'> & React.RefAttributes<SVGSVGElement>
  >;
  title: string;
}

export interface ESNIFormPopoverProps {
  ['aria-label']: string;
  content: Content[];
}

export function ESNIFormPopover({ content, ...props }: ESNIFormPopoverProps) {
  return (
    <Popover>
      <PopoverTrigger aria-label={props['aria-label']}>
        <CircleHelp className="size-4" role="presentation" />
      </PopoverTrigger>
      <PopoverContent align="start" className="sm:w-full sm:max-w-96" side="right">
        <ul className="space-y-4">
          {content.map(({ description, icon: Icon, title }) => (
            <li key={title}>
              <strong className="flex items-center gap-1 text-sm">
                <Icon className="size-4" role="presentation" />
                {title}
              </strong>
              <span className="text-xs">{description}</span>
            </li>
          ))}
        </ul>
      </PopoverContent>
    </Popover>
  );
}
